module.exports = __webpack_public_path__ + "img/bugger_02.a8b8accf.png";